import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Delay scroll to let mobile menu close animation complete
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 300);
    }
  };
  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="flex justify-between items-center" data-id="element-137">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={handleLogoClick} data-id="element-138">
            <img src="https://cdn.magicpatterns.com/uploads/piF3tygLKnzoL2Q5y3TGTn/LOGO_-_5000pxc.png" alt="KittyPot logo" className="h-24 w-24 lg:h-28 lg:w-28 object-contain rounded-full" data-id="element-139" />
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-140">
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-600 hover:text-kitty-dark font-medium transition-colors" data-id="element-141">
              How it works
            </button>
            <button onClick={() => scrollToSection('features')} className="text-gray-600 hover:text-kitty-dark font-medium transition-colors" data-id="element-142">
              Features
            </button>
            <button onClick={() => navigate('/faq')} className="text-gray-600 hover:text-kitty-dark font-medium transition-colors" data-id="element-143">
              FAQ
            </button>
            <button onClick={() => navigate('/about')} className="text-gray-600 hover:text-kitty-dark font-medium transition-colors" data-id="element-144">
              About
            </button>
            <button onClick={() => navigate('/contact')} className="text-gray-600 hover:text-kitty-dark font-medium transition-colors" data-id="element-145">
              Contact
            </button>
            <button onClick={() => scrollToSection('waitlist')} className="bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark px-5 py-2.5 rounded-full font-semibold transition-all shadow-sm hover:shadow-md active:scale-95" data-id="element-146">
              Join the waitlist
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-gray-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-147">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-148" /> : <Menu className="w-6 h-6" data-id="element-149" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-150">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-151">
            <div className="px-6 pt-4 pb-8 flex flex-col gap-2" data-id="element-152">
              <button onClick={() => scrollToSection('how-it-works')} className="text-left py-3.5 px-2 text-gray-700 font-medium text-lg active:bg-gray-50 rounded-xl transition-colors" data-id="element-153">
                How it works
              </button>
              <button onClick={() => scrollToSection('features')} className="text-left py-3.5 px-2 text-gray-700 font-medium text-lg active:bg-gray-50 rounded-xl transition-colors" data-id="element-154">
                Features
              </button>
              <button onClick={() => {
            setIsMobileMenuOpen(false);
            navigate('/faq');
          }} className="text-left py-3.5 px-2 text-gray-700 font-medium text-lg active:bg-gray-50 rounded-xl transition-colors" data-id="element-155">
                FAQ
              </button>
              <button onClick={() => {
            setIsMobileMenuOpen(false);
            navigate('/about');
          }} className="text-left py-3.5 px-2 text-gray-700 font-medium text-lg active:bg-gray-50 rounded-xl transition-colors" data-id="element-156">
                About
              </button>
              <button onClick={() => {
            setIsMobileMenuOpen(false);
            navigate('/contact');
          }} className="text-left py-3.5 px-2 text-gray-700 font-medium text-lg active:bg-gray-50 rounded-xl transition-colors" data-id="element-157">
                Contact
              </button>
              <button onClick={() => scrollToSection('waitlist')} className="bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark px-5 py-4 rounded-xl font-semibold text-center text-lg mt-3 active:scale-[0.98] transition-all" data-id="element-158">
                Join the waitlist
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}